import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex page-container" }
const _hoisted_2 = { class: "content p-4 w-100" }
const _hoisted_3 = { class: "card-title mt-0" }
const _hoisted_4 = { class: "mr-3 ml-3 content-body" }
const _hoisted_5 = {
  key: 1,
  class: "d-flex justify-content-end mt-3"
}

import { ref, watch } from 'vue';
import MileageCorrectionSearchForm from '@/components/MileageCorrection/MileageCorrectionSearchForm.vue';
import MileageCorrectionTable from '@/components/MileageCorrection/MileageCorrectionTable.vue';
import Api from '@/services/api/ApiServiceFabrick';
import { formatDate } from '@/services/functions';
import i18n from '@/lang/i18n';
import type getOperationOffice from '@/types/responses/getOperationOffice';
import type getDepartmentResponse from '@/types/responses/getDepartment';
import type DeliveryPlan from '@/types/DeliveryPlan';

const MAX_DATE_RANGE = 31;


export default /*@__PURE__*/_defineComponent({
  __name: 'VehicleMileageCorrection',
  props: {
    showFlash: { type: Function }
  },
  setup(__props: any) {

const props = __props;

const selectedOperationOffice = ref<getOperationOffice | null>(null);
const selectedDepartment = ref<getDepartmentResponse | undefined>(undefined);
const selectedVehicle = ref<any | null>(null);
const operations = ref<DeliveryPlan[]>([]);
const loading = ref(false);
const saving = ref(false);
const currentPage = ref(1);
const totalPage = ref(0);
const itemsPerPage = ref(50);
const allElementsCount = ref(0);
const searched = ref(false);

const correctionBaseId = ref<string | null>(null);
const correctionOutOfServiceMeter = ref<number | null>(null);

function defaultDateRange(): Date[] {
  const today = new Date();
  const from = new Date();
  from.setDate(from.getDate() - (MAX_DATE_RANGE - 1));
  return [from, today];
}

const dateRange = ref<Date[]>(defaultDateRange());

async function fetchOperations() {
  if (!selectedVehicle.value || !selectedOperationOffice.value) {
    return;
  }

  loading.value = true;
  operations.value = [];
  correctionBaseId.value = null;
  correctionOutOfServiceMeter.value = null;

  const daterange = `${formatDate(dateRange.value[0], '/')} - ${formatDate(dateRange.value[1], '/')}`;

  try {
    const res = await Api().getDailyReports({
      operation_office_id: selectedOperationOffice.value.id,
      car_id: selectedVehicle.value.id,
      driver_id: null,
      account_id: null,
      daterange,
      delivery_date: 1,
      return_date: 0,
      page: currentPage.value,
    });
    operations.value = res.items;
    totalPage.value = res.total_page;
    itemsPerPage.value = res.per_page;
    allElementsCount.value = res.total;
    searched.value = true;
  } finally {
    loading.value = false;
  }
}

function search() {
  currentPage.value = 1;
  operations.value = [];
  searched.value = false;
  fetchOperations();
}

function resetCorrection() {
  correctionBaseId.value = null;
  correctionOutOfServiceMeter.value = null;
}

watch(selectedVehicle, () => {
  operations.value = [];
  searched.value = false;
});

watch(currentPage, () => {
  if (selectedVehicle.value) {
    fetchOperations();
  }
});

async function save() {
  if (!correctionBaseId.value || correctionOutOfServiceMeter.value === null || !selectedVehicle.value) {
    return;
  }

  saving.value = true;

  try {
    await Api().applyMileageCorrection({
      delivery_plan_id: correctionBaseId.value,
      vehicle_id: selectedVehicle.value.id,
      out_of_service_meter: correctionOutOfServiceMeter.value,
      start_date: formatDate(dateRange.value[0], '/'),
      end_date: formatDate(dateRange.value[1], '/'),
    });
    props.showFlash?.(i18n.global.t('pages.common.messages.success'), 'success', true);
    await fetchOperations();
  } finally {
    saving.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", _hoisted_3, _toDisplayString(_unref(i18n).global.t('sideMenue.dailyReport.mileageCorrection')), 1),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(MileageCorrectionSearchForm, {
          selectedOperationOffice: selectedOperationOffice.value,
          "onUpdate:selectedOperationOffice": _cache[0] || (_cache[0] = ($event: any) => ((selectedOperationOffice).value = $event)),
          selectedDepartment: selectedDepartment.value,
          "onUpdate:selectedDepartment": _cache[1] || (_cache[1] = ($event: any) => ((selectedDepartment).value = $event)),
          selectedVehicle: selectedVehicle.value,
          "onUpdate:selectedVehicle": _cache[2] || (_cache[2] = ($event: any) => ((selectedVehicle).value = $event)),
          dateRange: dateRange.value,
          "onUpdate:dateRange": _cache[3] || (_cache[3] = ($event: any) => ((dateRange).value = $event)),
          loading: loading.value,
          maxDateRange: MAX_DATE_RANGE,
          onSearch: search
        }, null, 8, ["selectedOperationOffice", "selectedDepartment", "selectedVehicle", "dateRange", "loading"]),
        (selectedVehicle.value && searched.value)
          ? (_openBlock(), _createBlock(MileageCorrectionTable, {
              key: 0,
              trips: operations.value,
              loading: loading.value,
              totalPage: totalPage.value,
              itemsPerPage: itemsPerPage.value,
              allElementsCount: allElementsCount.value,
              currentPage: currentPage.value,
              "onUpdate:currentPage": _cache[4] || (_cache[4] = ($event: any) => ((currentPage).value = $event)),
              correctionBaseId: correctionBaseId.value,
              "onUpdate:correctionBaseId": _cache[5] || (_cache[5] = ($event: any) => ((correctionBaseId).value = $event)),
              correctionOutOfServiceMeter: correctionOutOfServiceMeter.value,
              "onUpdate:correctionOutOfServiceMeter": _cache[6] || (_cache[6] = ($event: any) => ((correctionOutOfServiceMeter).value = $event)),
              class: "mt-4"
            }, null, 8, ["trips", "loading", "totalPage", "itemsPerPage", "allElementsCount", "currentPage", "correctionBaseId", "correctionOutOfServiceMeter"]))
          : _createCommentVNode("", true),
        (selectedVehicle.value && searched.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_v_btn, {
                class: "ma-2 reset-btn",
                disabled: correctionBaseId.value === null,
                onClick: resetCorrection
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.common.button.reset')), 1)
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_v_btn, {
                class: "ma-2 exec-btn",
                disabled: correctionBaseId.value === null,
                loading: saving.value,
                onClick: save
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.common.button.conservation')), 1)
                ]),
                _: 1
              }, 8, ["disabled", "loading"])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})